import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_CONFIG } from './config';


// Initialize Stripe with the publishable key
let stripePromise: Promise<any> | null = null;

export const getStripe = () => {
  if (!stripePromise) {
    console.log('Initializing Stripe.js...');
    stripePromise = loadStripe(STRIPE_CONFIG.publishableKey);
    
    // Add a catch handler to log any errors
    stripePromise.catch(error => {
      console.error('Failed to load Stripe.js:', error);
    });
  }
  return stripePromise;
};